import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navigationList: [
      { title: "Overview", id: 0, path: '/' },
      { title: "Press Releases", id: 1, path: '/releases' },
      { title: "SEC Filings", id: 2, path: '/sec' },
      { title: "Stock Info", id: 3, path: '/stock' },
      { title: "Directors", id: 4, path: '/directors' },
      { title: "Governance", id: 5, path: '/governance'  },
      { title: "Management", id: 6, path: '/management' },
      { title: "IR Contact", id: 7, path: '/contact' },
      { title: "FAQs", id: 8, path: '/faqs' },
      { title: "Email Alerts", id: 9, path: '/email' },
    ],
    //---------------总共可视化屏幕宽度
    screenWidth: '',
    // 当前屏幕的可视化高度
    clientHeight: "",
    appPath: '',
    navActive: ''
  },
  getters: {
  },
  mutations: {
    screenWidthWatch(state, number) {
      state.screenWidth = number
    },
    clientHeightWatch(state, number) {
      state.clientHeight = number
    },
    appPathWatch(state, str) {
      state.appPath = str
    },
    navActiveWacth(state, number) {
      state.navActive = number
    }
  },
  actions: {
  },
  modules: {
  }
})
